import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BulkUpdateTasks } from '../../redux/taskSlice';
import { Menu, MenuTrigger, MenuPopover, MenuList, MenuDivider } from '@fluentui/react-components';
import { Calendar16Regular, ChevronDown12Regular } from '@fluentui/react-icons';
import styles from './css/index.module.css';

const BulkDeadlineUpdateMenu = ({ selectedRows, onBulkUpdateComplete, children }) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);

    // Get today's date in YYYY-MM-DD format
    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };

    const [deadline, setDeadline] = useState('');

    const handleBulkDeadlineUpdate = async () => {
        if (!selectedRows || selectedRows.length === 0) return;

        setIsUpdating(true);
        try {
            // Update all selected tasks with the new deadline using bulk update
            await dispatch(
                BulkUpdateTasks({
                    taskIds: selectedRows,
                    updates: {
                        deadline: deadline || null,
                    },
                    suppressToast: true,
                }),
            );

            // Call the completion callback
            if (onBulkUpdateComplete) {
                onBulkUpdateComplete({ deadline }, selectedRows.length);
            }

            setOpen(false);
        } catch (error) {
            console.error('Error updating bulk task deadline:', error);
        } finally {
            setIsUpdating(false);
        }
    };

    const handleBulkDeadlineClear = async () => {
        if (!selectedRows || selectedRows.length === 0) return;

        setIsUpdating(true);
        try {
            // Clear deadline for all selected tasks using bulk update
            await dispatch(
                BulkUpdateTasks({
                    taskIds: selectedRows,
                    updates: {
                        deadline: null,
                    },
                    suppressToast: true,
                }),
            );

            // Call the completion callback
            if (onBulkUpdateComplete) {
                onBulkUpdateComplete({ deadline: null }, selectedRows.length);
            }
            setOpen(false);
        } catch (error) {
            console.error('Error clearing bulk task deadline:', error);
        } finally {
            setIsUpdating(false);
        }
    };

    return (
        <Menu open={open} onOpenChange={(e, data) => setOpen(data.open)}>
            <MenuTrigger>
                {children || (
                    <div className={styles.bulkUpdateMenu} style={{ opacity: isUpdating ? 0.6 : 1 }}>
                        Deadline <ChevronDown12Regular className="ms-1" />
                    </div>
                )}
            </MenuTrigger>
            <MenuPopover style={{ width: '300px', minWidth: '300px' }}>
                <MenuList>
                    <div className="p-2">
                        <div className="d-flex align-items-center gap-2 mb-2">
                            <Calendar16Regular />
                            <span className={styles.tableFilterHeader}>Set Deadline</span>
                        </div>

                        <div className="mb-3">
                            <label className="form-label small mb-0" style={{ fontSize: '10px' }}>
                                Deadline
                            </label>
                            <input
                                type="date"
                                className={'form-control form-control-sm ' + styles.filterSelect}
                                value={deadline || ''}
                                onChange={e => setDeadline(e.target.value)}
                                disabled={isUpdating}
                            />
                        </div>

                        <div className="d-flex gap-2 justify-content-between">
                            <span
                                className={styles.secondaryBtnText + ' ms-1'}
                                onClick={handleBulkDeadlineUpdate}
                                style={{
                                    opacity: isUpdating ? 0.6 : 1,
                                    cursor: isUpdating ? 'not-allowed' : 'pointer',
                                }}>
                                Save deadline
                            </span>
                            <span
                                className={styles.secondaryBtnText + ' ms-1'}
                                onClick={handleBulkDeadlineClear}
                                style={{
                                    opacity: isUpdating ? 0.6 : 1,
                                    cursor: isUpdating ? 'not-allowed' : 'pointer',
                                }}>
                                Clear
                            </span>
                        </div>
                    </div>
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};

export default BulkDeadlineUpdateMenu;
